import { createContext, useState, useContext, useCallback } from "react";
import PropTypes from "prop-types";

export const NavContext = createContext();

export const NavProvider = ({ children }) => {
  const stepIds = {
    määrä: 0,
    osoite: 1,
    pumppu: 2,
    aika: 3,
    betoni: 4,
    lattia: 5, // You can remove the eslint-disable comments now
    yhteenveto: 6,
    process: 7,
    toimittajaSelector: 8,
    betoniM3: 9,
    betoniJaM3: 10,
  };

  // eslint-disable-next-line no-unused-vars
  const tabIds = {
    tilaus: 0,
    toimitus: 7,
    kuvat: 4,
    toiminnot: 1,
    loki: 3,
    process: 5,
    tarjous: 9,
    lasku: 6,
    asetukset: 8,
  };

  const [tabValue, setTabValue] = useState(0);
  const [stepId, setStepId] = useState(6);

  const doSetStepId = useCallback(
    (stepId) => {
      setStepId(stepId);
    },
    [stepId]
  );
  const doSetTabValue = useCallback(
    (tabValue) => {
      setTabValue(tabValue);
    },
    [tabValue]
  );

  const navToM3 = () => {
    doSetStepId(stepIds.määrä);
  };
  const navToAika = () => {
    doSetStepId(stepIds.aika);
  };
  const navToPumppu = () => {
    doSetStepId(stepIds.pumppu);
  };
  const navToYhteenveto = () => {
    doSetStepId(stepIds.yhteenveto);
  };
  const navToToimittajaSelector = () => {
    doSetStepId(stepIds.toimittajaSelector);
  };
  const navToBetoniM3 = () => {
    doSetStepId(stepIds.betoniM3);
  };
  const navToBetoniJaM3 = () => {
    doSetStepId(stepIds.betoniJaM3);
  };
  const navToBetoni = () => {
    doSetStepId(stepIds.betoni);
  };
  const navToProcess = () => {
    doSetStepId(stepIds.process);
  };
  const navToLaskutus = () => {
    setTabValue(6);
  };

  return (
    <NavContext.Provider
      value={{
        tabValue,
        doSetTabValue,
        stepId,
        doSetStepId,
        navToM3,
        navToAika,
        navToPumppu,
        navToYhteenveto,
        navToToimittajaSelector,
        navToBetoniM3,
        navToBetoniJaM3,
        navToBetoni,
        navToProcess,
        navToLaskutus,
      }}>
      {children}
    </NavContext.Provider>
  );
};

export const useNavData = () => useContext(NavContext);

NavProvider.propTypes = {
  children: PropTypes.node.isRequired,
  keikkaId: PropTypes.number,
};
